const noNav = [
  'quickapp',
  'gtgjapp',
  'zfb',
  'quickappHW',
  'qqapp-hbgj',
  'gtdx-oppo',
  'gtdx-vivo',
  'gtdx-other',
  'gtdx-huawei',
  'hbdx-oppo',
  'hbdx-vivo',
  'hbdx-other',
  'hbdx-huawei',
  'huoli-car',
  'sa', // 南航
];

export default {
  noNav
};



// WEBPACK FOOTER //
// ./src/partner/source.js